<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M4 14H12C13.1046 14 14 13.1046 14 12V9C14 7.89543 13.1046 7 12 7H4C2.89543 7 2 7.89543 2 9V12C2 13.1046 2.89543 14 4 14Z"
        stroke="var(--bg-color)" stroke-width="2" />
    <path d="M12 8V4C12 2.89543 11.1046 2 10 2H6C4.89543 2 4 2.89543 4 4V8" stroke="var(--bg-color)" stroke-width="2" />
    <circle cx="8" cy="10" r="1" fill="var(--bg-color)" />
    <path d="M8 10V12" stroke="var(--bg-color)" />
</svg>

